import React from 'react';

import { GenericSearchBar, useSearchBar } from '@europrocurement/l2d-modules';
import { useParcoursFormalitreHeader } from '@europrocurement/l2d-modules/modules/ParcoursFormalite/provider';
import { Box, Container } from '@mui/system';
import { Stepper } from '@europrocurement/flexy-components';

const L2DFCustomHeader: React.FunctionComponent = function () {
    const { isSearchBarPath } = useSearchBar();
    const { isParcoursPath, steps } = useParcoursFormalitreHeader();
    if (isSearchBarPath) {
        return <GenericSearchBar />;
    }

    if (isParcoursPath) {
        return (
            <Box sx={{ width: '100%', padding: 'auto' }}>
                <Container maxWidth="md">
                    <Stepper steps={steps} />
                </Container>
            </Box>
        );
    }

    return null;
};

export default L2DFCustomHeader;
